export default {

  /////////////////////////개발/////////////////////////////

  // appName: 'bbt',

  // serverProtocol: "http",
  // serverIp: "localhost",
  // serverPort: "19001",
  // // serverPort: "18001",
  // clientIp: "localhost",
  // clientPort: "3000",

  // // isFoundationInFee: false,
  // // isPurchaseInFee: true,

  // //naver map client key
  // clientId: "",
  // clientSecret: "",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],

  // 개발용DB STEM
  // appName: 'stemwallet',
  // serverProtocol: "http",
  // serverIp: "localhost",
  // serverPort: "58545",
  // // serverPort: "18001",
  // clientIp: "localhost",
  // clientPort: "3000",

  // isFoundationInFee: false,
  // isPurchaseInFee: true,

  // //naver map client key
  // clientId: "",
  // clientSecret: "",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],
 
  // appName: 'sbwallet',
  // serverProtocol: "http",
  // serverIp: "localhost",
  // serverPort: "58545",
  // // serverPort: "58545",
  // clientIp: "localhost",
  // clientPort: "3000",

  // isFoundationInFee: false,
  // isPurchaseInFee: true,

  // // //naver map client key
  // clientId: "",
  // clientSecret: "",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],



  ///////////////////////////운영/////////////////////////////

  // // SB wallet
  // serverProtocol: "https",
  // appName: 'sbwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.sbpay.co.kr",
  // serverPort: "48545",
  // clientIp: "admin.sbpay.co.kr",
  // clientPort: "443",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  // ],

  // cbc wallet
  // serverProtocol: "https",
  // appName: 'cbcwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.otcex.io",
  // serverPort: "19001",
  // clientIp: "admin.otcex.io",
  // clientPort: "443",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],

  // tiger wallet
  // serverProtocol: "https",
  // appName: 'tigerwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.bit-tiger.kr",
  // serverPort: "18001",
  // clientIp: "admin.bit-tiger.kr",
  // clientPort: "443",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],

  // tmed wallet
  // serverProtocol: "https",
  // appName: 'MDtalk WALLET',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "admin.mdsqr.io",
  // serverPort: "19001",
  // clientIp: "admin.mdsqr.io",
  // clientPort: "443",
  // // naver map client key
  // clientId: "",
  // clientSecret: "",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  // ],

 // stem wallet
  // serverProtocol: "https",
  // appName: 'stemwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.l7stem.com",
  // serverPort: "19001",
  // clientIp: "admin.l7stem.com",
  // clientPort: "8000",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  //   {code: 'En', name: '영어'},
  //   {code: 'Cn', name: '중국어'},
  //   {code: 'Ja', name: '일본어'},
  //   {code: 'Vi', name: '베트남어'},
  // ],

   // western wallet
  //  serverProtocol: "https",
  //  appName: 'western',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.l7stem.com",
  //  serverPort: "29001",
  //  clientIp: "admin.l7stem.com",
  //  clientPort: "8888",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],



  // plap wallet
  // serverProtocol: "https",
  // appName: 'plapwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.plapwallet.com",
  // serverPort: "19001",
  // clientIp: "admin.plapwallet.com",
  // clientPort: "8000",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  // ],

  // mozex wallet
  // serverProtocol: "https",
  // appName: 'mozexwallet',
  // isFoundationInFee: false,
  // isPurchaseInFee: true,
  // serverIp: "back.mozexwallet.com",
  // serverPort: "19001",
  // clientIp: "admin.mozexwallet.com",
  // clientPort: "8000",
  // // naver map client key
  // clientId: "r06yvi25vl",
  // clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  // languages: [
  //   {code: 'Ko', name: '한국어'},
  // ],


   // jfoundation wallet
  //  serverProtocol: "https",
  //  appName: 'jfoundation',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "admin.jfda.io",
  //  serverPort: "19001",
  //  clientIp: "admin.jfda.io",
  //  clientPort: "8000",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // tlab wallet
  //  serverProtocol: "https",
  //  appName: 'tlab',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "admin.tlabwallet.com",
  //  serverPort: "19001",
  //  clientIp: "admin.tlabwallet.com",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // snt wallet
  //  serverProtocol: "https",
  //  appName: 'snt',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "admin.sntwallet.com",
  //  serverPort: "19001",
  //  clientIp: "admin.sntwallet.com",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],
   
   // sunpara wallet
  //  serverProtocol: "https",
  //  appName: 'sunpara',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "wback.sunpara.co.kr",
  //  serverPort: "19001",
  //  clientIp: "wadmin.sunpara.co.kr",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // stakinghouse wallet
  //  serverProtocol: "https",
  //  appName: 'stakinghouse',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.stakinghouse.net",
  //  serverPort: "19001",
  //  clientIp: "admin.stakinghouse.net",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // bluecoin wallet
  //  serverProtocol: "https",
  //  appName: 'bluecoin',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.bluecoin.biz",
  //  serverPort: "19001",
  //  clientIp: "admin.bluecoin.biz",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // moneytree wallet
  //  serverProtocol: "https",
  //  appName: 'moneytree',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.moneytreewallet.com",
  //  serverPort: "19001",
  //  clientIp: "admin.moneytreewallet.com",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],
   // jksto wallet
  //  serverProtocol: "https",
  //  appName: 'jksto',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.jksto.site",
  //  serverPort: "19001",
  //  clientIp: "admin.jksto.site",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'}
  //  ],
  
   // mozglobal wallet
  //  serverProtocol: "https",
  //  appName: 'moz2',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.mozglobal.app",
  //  serverPort: "19001",
  //  clientIp: "admin.mozglobal.app",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // cass wallet
  //  serverProtocol: "https",
  //  appName: 'cass',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.casscoin.net",
  //  serverPort: "19001",
  //  clientIp: "admin.casscoin.net",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Cn', name: '중국어'},
  //    {code: 'Ja', name: '일본어'},
  //    {code: 'Vi', name: '베트남어'},
  //  ],

   // swaptalk wallet
   serverProtocol: "https",
   appName: 'swaptalk',
   isFoundationInFee: false,
   isPurchaseInFee: true,
   serverIp: "aback.7mwallet.com",
   serverPort: "443",
   clientIp: "admin.7mwallet.com",
   clientPort: "80",
   // naver map client key
   clientId: "r06yvi25vl",
   clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
   languages: [
     {code: 'Ko', name: '한국어'},
     {code: 'En', name: '영어'},
     {code: 'Cn', name: '중국어'},
     {code: 'Ja', name: '일본어'},
     {code: 'Vi', name: '베트남어'},
     {code: 'Id', name: '인도네시아어'},
   ],

   // hwangchil wallet
  //  serverProtocol: "https",
  //  appName: 'hwangchil',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.hwangchilcoin.com",
  //  serverPort: "19001",
  //  clientIp: "admin.hwangchilcoin.com",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Ja', name: '일본어'},
  //  ],
   // bitcoinskr wallet
  //  serverProtocol: "https",
  //  appName: 'bitcoinskr',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.nodemask.io",
  //  serverPort: "19001",
  //  clientIp: "admin.nodemask.io",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Ja', name: '일본어'},
  //  ],
  
   // accountbit wallet
  //  serverProtocol: "https",
  //  appName: 'accountbit',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.accountbit.info",
  //  serverPort: "19001",
  //  clientIp: "admin.accountbit.info",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Ja', name: '일본어'},
  //  ],
  
   // rom wallet
  //  serverProtocol: "https",
  //  appName: 'romwallet',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "aback.romrom.io",
  //  serverPort: "443",
  //  clientIp: "wadmin.romrom.io",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Ja', name: '일본어'},
  //  ],
   // hollywood wallet
  //  serverProtocol: "https",
  //  appName: 'hollywood',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "back.hollywoodcoin.net",
  //  serverPort: "19001",
  //  clientIp: "admin.hollywoodcoin.net",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Ja', name: '일본어'},
  //  ],
   // bbt wallet
  //  serverProtocol: "https",
  //  appName: 'bbt',
  //  isFoundationInFee: false,
  //  isPurchaseInFee: true,
  //  serverIp: "aback.blockballwallet.com",
  //  serverPort: "443",
  //  clientIp: "admin.blockballwallet.com",
  //  clientPort: "80",
  //  // naver map client key
  //  clientId: "r06yvi25vl",
  //  clientSecret: "zxbz0455mCXQdp8u4aPzDRhUZkSajLNThQH3ZkbZ",
  //  languages: [
  //    {code: 'Ko', name: '한국어'},
  //    {code: 'En', name: '영어'},
  //    {code: 'Zh', name: '중국어'},
  //  ],
};


